import { CardPrinterPagePrinterTab } from "@features/card-printer/components/CardPrinterPagePrinterTab";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/assets/card-printer/printers")({
    component: CardPrinterPagePrinterTab,
});
